import {createApp} from "vue";
import ProductQueryResults from "Vue/components/productQueryResults/ProductQueryResults.vue";
import ProductQueryResultsGrid from "Vue/components/productQueryResults/ProductQueryResultsGrid.vue";

export namespace ProductQueryResultsApp {
	let initProductQueryResults = () => {
		let queryResultsModules = document.querySelectorAll('.pqr-module');

		if(!queryResultsModules.length) {
			return;
		}

		queryResultsModules.forEach((module, index) => {
			module.setAttribute("id", `productQueryResults${index}`);

			if(module.classList.contains("js-product-query-results-grid")) {
				const pqr = createApp(ProductQueryResultsGrid);
				pqr.mount(`#productQueryResults${index}`);
			} else {
				const pqr = createApp(ProductQueryResults);
				pqr.mount(`#productQueryResults${index}`);
			}

		});
	}

	export const init = () => {
		initProductQueryResults();
	}
}



/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', ProductQueryResultsApp.init);
} else {  // `DOMContentLoaded` has already fired
	ProductQueryResultsApp.init();
}
